/**
 * Impact Theme Fitment Finder
 * Vanilla JS, no external deps.
 */
(function() {
  'use strict';

  class FitmentFinder {
    constructor(element) {
      this.modal = element;
      this.container = this.modal.querySelector('.ff-container');
      this.progressBar = this.modal.querySelector('.ff-progress-fill');
      this.data = null;
      this.currentProduct = this.modal.dataset.productHandle || 'default';
      
      this.state = {
        step: 1,
        category: null,
        make: null,
        model: null
      };

      this.ui = {
        loading: this.modal.querySelector('.ff-loading'),
        step1: this.modal.querySelector('[data-step="1"]'),
        step2: this.modal.querySelector('[data-step="2"]'),
        step3: this.modal.querySelector('[data-step="3"]'),
        result: this.modal.querySelector('[data-step="result"]'),
        form: this.modal.querySelector('[data-step="form"]'),
        categoryList: document.getElementById('ff-category-list'),
        makeList: document.getElementById('ff-make-list'),
        modelList: document.getElementById('ff-model-list'),
        resultContent: document.getElementById('ff-result-content'),
        searchMake: document.getElementById('ff-search-make'),
        searchModel: document.getElementById('ff-search-model')
      };

      this.init();
    }

    init() {
      // Event Delegation
      this.modal.addEventListener('click', (e) => this.handleClicks(e));
      
      // Search Listeners
      this.ui.searchMake.addEventListener('input', (e) => this.filterList(e.target.value, 'ff-make-list'));
      this.ui.searchModel.addEventListener('input', (e) => this.filterList(e.target.value, 'ff-model-list'));
      
      // Keydown (Escape)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('is-open')) this.close();
      });

      // Inside your init() or constructor listener
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-fitment-open]');
  if (trigger) {
    e.preventDefault();
    this.lastTrigger = trigger; // Save the reference
    this.open();
  }
});

      // Data Load
      this.fetchData();
    }

    async fetchData() {
      try {
        const response = await fetch(window.fitmentDataUrl);
        if(!response.ok) throw new Error('Failed to load');
        const json = await response.json();
        
        // Use product specific data or fallback to default
        this.data = json[this.currentProduct] || json['default'] || {};
        
        this.ui.loading.style.display = 'none';
this.state.category = 'Motorcycle';
this.selectCategory('Motorcycle');
      } catch (err) {
        console.error('Fitment Data Error:', err);
        this.ui.loading.textContent = 'Error loading data. Please use the contact form.';
        // Fallback to form
        setTimeout(() => this.goToStep('form'), 1000);
      }
    }

   open() {
  this.modal.style.display = 'flex'; 
  this.modal.classList.add('is-open');
  
  // Accessibility Fixes:
  this.modal.setAttribute('aria-hidden', 'false');
  this.modal.removeAttribute('inert');
  
  document.body.style.overflow = 'hidden'; 
  this.emitEvent('modal_open');
  this.reset();
  
  // Focus the close button or the container after a tiny delay 
  // to ensure the browser has registered the removal of 'inert'
  setTimeout(() => {
    this.modal.querySelector('.ff-close-btn').focus();
  }, 50);
}
    
    // Specifically for form success re-opening
    openSuccess() {
        this.modal.classList.add('is-open');
        this.goToStep('form');
    }

   close() {
  this.modal.classList.remove('is-open');
  document.body.style.overflow = '';
  
  // Accessibility Fixes:
  this.modal.setAttribute('aria-hidden', 'true');
  this.modal.setAttribute('inert', '');

  setTimeout(() => {
    if (!this.modal.classList.contains('is-open')) {
      this.modal.style.display = 'none';
    }
  }, 300);

  // Return focus to the button that opened it (Standard A11y practice)
  if (this.lastTrigger) {
    this.lastTrigger.focus();
  }
}

    reset() {
  this.state = { step: 2, category: 'Motorcycle', make: null, model: null };
  this.selectCategory('Motorcycle');
}

    handleClicks(e) {
  const target = e.target;
  
  // Close
  if (target.hasAttribute('data-ff-close')) {
    this.close();
    return;
  }

  // --- NEW: Lock Switcher Logic ---
  const lockTab = target.closest('.ff-lock-tab');
  if (lockTab) {
    const selectedLock = lockTab.dataset.lock;
    // We pass the current model and the newly selected lock to re-render
    this.renderResult(this.state.model, selectedLock);
    return;
  }
  // --------------------------------

  // Actions
  const actionEl = target.closest('[data-ff-action]');
  const action = actionEl ? actionEl.dataset.ffAction : null;
  if (action) {
    if (action === 'back') this.goBack();
    if (action === 'restart') this.reset();
    if (action === 'go-other') this.goToStep('form');
    return;
  }

  // Selections
  const optionBtn = target.closest('.ff-btn-option');
  if (optionBtn) {
    const value = optionBtn.dataset.value;
    const type = optionBtn.dataset.type; // category, make, model

    if (type === 'category') this.selectCategory(value);
    if (type === 'make') this.selectMake(value);
    if (type === 'model') this.selectModel(value);
  }
}

    goToStep(step) {
      // Hide all
      Object.values(this.ui).forEach(el => {
        if(el instanceof HTMLElement && el.classList.contains('ff-step')) {
           el.classList.add('hidden');
        }
      });

      // Show specific
      if (step === 'result') {
        this.ui.result.classList.remove('hidden');
        this.progressBar.style.width = '100%';
      } else if (step === 'form') {
        this.ui.form.classList.remove('hidden');
        this.progressBar.style.width = '100%';
      } else {
        this.ui[`step${step}`].classList.remove('hidden');
        this.progressBar.style.width = `${step * 33}%`;
      }
      
      this.state.step = step;
    }

    goBack() {
  if (this.state.step === 'result') this.goToStep(3);
  else if (this.state.step === 3) this.goToStep(2);
  else if (this.state.step === 'form') this.goToStep(2);
}

    /* --- Logic --- */

    renderCategories() {
      const cats = Object.keys(this.data);
      let html = '';
      cats.forEach(cat => {
        html += `<button type="button" class="ff-btn-option" data-type="category" data-value="${cat}">${cat}</button>`;
      });
      this.ui.categoryList.innerHTML = html;
    }

    selectCategory(cat) {
      this.state.category = cat;
      this.emitEvent('category_selected', { category: cat });
      
      const makes = this.data[cat] ? Object.keys(this.data[cat]) : [];
      this.renderList(this.ui.makeList, makes, 'make');
      
      // Handle Search visibility
      if (makes.length > 15) this.ui.searchMake.classList.remove('hidden');
      else this.ui.searchMake.classList.add('hidden');
      this.ui.searchMake.value = ''; // Reset search

      this.goToStep(2);
    }

    selectMake(make) {
      this.state.make = make;
      this.emitEvent('make_selected', { make: make });

      const models = this.data[this.state.category][make] ? Object.keys(this.data[this.state.category][make]) : [];
      this.renderList(this.ui.modelList, models, 'model');

      if (models.length > 15) this.ui.searchModel.classList.remove('hidden');
      else this.ui.searchModel.classList.add('hidden');
      this.ui.searchModel.value = '';

      this.goToStep(3);
    }

    selectModel(model) {
      this.state.model = model;
      this.emitEvent('model_selected', { model: model });
      this.renderResult(model);
      this.goToStep('result');
    }

    renderList(container, items, type) {
      let html = '';
      items.sort().forEach(item => {
        html += `<button type="button" class="ff-btn-option" data-type="${type}" data-value="${item}">${item}</button>`;
      });
      container.innerHTML = html;
    }

    filterList(query, listId) {
      const list = document.getElementById(listId);
      const buttons = list.querySelectorAll('button');
      const q = query.toLowerCase();
      buttons.forEach(btn => {
        const text = btn.textContent.toLowerCase();
        btn.style.display = text.includes(q) ? '' : 'none';
      });
    }

    renderResult(model, activeLockKey = null) {
  const modelData = this.data[this.state.category][this.state.make][model];

  if (!modelData || !modelData.locks) {
    this.ui.resultContent.innerHTML = '<p>Data for this model is currently being updated.</p>';
    return;
  }

  const lockKeys = Object.keys(modelData.locks);
  const currentLockKey = activeLockKey || lockKeys[0];
  const resultData = modelData.locks[currentLockKey];
  const mediaItems = resultData.media || [];
  const hasMedia = mediaItems.length > 0;

  // 1. Lock selector tabs
  let selectorHtml = '<div class="ff-lock-selector">';
  lockKeys.forEach(k => {
    const active = k === currentLockKey ? 'is-active' : '';
    selectorHtml += `<button type="button" class="ff-lock-tab ${active}" data-lock="${k}">${k}</button>`;
  });
  selectorHtml += '</div>';

  // 2. Media
  let mediaHtml = '';
  if (!hasMedia) {
    mediaHtml = `<div class="ff-media-placeholder">
      <span class="ff-coming-soon-badge">Photo coming soon</span>
    </div>`;
  } else if (mediaItems.length === 1) {
    mediaHtml = this.renderSingleMedia(mediaItems[0], currentLockKey, model);
  } else {
    // Gallery
    let slides = '';
    mediaItems.forEach((item, i) => {
      slides += `<div class="ff-slide${i === 0 ? ' is-active' : ''}" data-index="${i}">
        ${this.renderSingleMedia(item, currentLockKey, model)}
        ${item.caption ? `<p class="ff-caption">${item.caption}</p>` : ''}
      </div>`;
    });

    let dots = '<div class="ff-dots">';
    mediaItems.forEach((_, i) => {
      dots += `<button type="button" class="ff-dot${i === 0 ? ' is-active' : ''}" data-dot="${i}" aria-label="Go to slide ${i + 1}"></button>`;
    });
    dots += '</div>';

    mediaHtml = `<div class="ff-gallery" data-current="0" data-total="${mediaItems.length}">
      <div class="ff-slides">${slides}</div>
      <button type="button" class="ff-arrow ff-arrow--prev" aria-label="Previous">&#8592;</button>
      <button type="button" class="ff-arrow ff-arrow--next" aria-label="Next">&#8594;</button>
      ${dots}
    </div>`;
  }

  // 3. Caption (single media only — gallery captions are per-slide)
  const captionHtml = mediaItems.length === 1 && mediaItems[0].caption
    ? `<p class="ff-caption">${mediaItems[0].caption}</p>`
    : mediaItems.length === 0 ? '' : '';

  // 4. Render
  this.ui.resultContent.innerHTML = `
    <h3 class="ff-result-title">${this.state.make} ${model}</h3>
    ${selectorHtml}
    ${mediaHtml}
    ${captionHtml}
    ${resultData.notes ? `<p class="ff-notes">${resultData.notes}</p>` : ''}
  `;

  // 5. Init gallery if needed
  if (mediaItems.length > 1) {
    this.initGallery(this.ui.resultContent.querySelector('.ff-gallery'));
  }
}

renderSingleMedia(item, lockKey, model) {
  if (!item.url) return '';
  if (item.url.includes('vimeo.com')) {
    const vimeoId = item.url.split('/').pop();
    return `<div class="ff-media-container" style="position:relative;padding-top:56.25%;">
      <iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&muted=1&loop=1"
        style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"
        allow="autoplay; fullscreen" allowfullscreen></iframe>
    </div>`;
  } else if (item.type === 'video' || item.url.includes('.mp4')) {
    return `<div class="ff-media-container"><video src="${item.url}" controls playsinline autoplay muted loop style="width:100%"></video></div>`;
  } else {
    return `<div class="ff-media-container"><img src="${item.url}" alt="Litelok ${lockKey} on ${model}" style="width:100%"></div>`;
  }
}

initGallery(gallery) {
  if (!gallery) return;
  let current = 0;
  const total = parseInt(gallery.dataset.total);
  const slides = gallery.querySelectorAll('.ff-slide');
  const dots = gallery.querySelectorAll('.ff-dot');

  const goTo = (index) => {
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    current = (index + total) % total;
    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
  };

  // Arrows
  gallery.querySelector('.ff-arrow--prev').addEventListener('click', () => goTo(current - 1));
  gallery.querySelector('.ff-arrow--next').addEventListener('click', () => goTo(current + 1));

  // Dots
  dots.forEach(dot => {
    dot.addEventListener('click', () => goTo(parseInt(dot.dataset.dot)));
  });

  // Swipe
  let touchStartX = 0;
  gallery.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  gallery.addEventListener('touchend', (e) => {
    const diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
  }, { passive: true });
}

emitEvent(name, detail = {}) {
      const event = new CustomEvent(`litelok:fitment_${name}`, {
        detail: { ...detail, product: this.currentProduct }
      });
      window.dispatchEvent(event);
    }
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('ff-modal');
    if (modal) {
      window.FitmentFinder = new FitmentFinder(modal);
    }
  });
})();